module.exports = __webpack_public_path__ + "static/media/InfoCourses.448b5875.svg";